import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { TostMsg } from "../../../App";
import { useFormik } from "formik";
import * as Yup from "yup";

const AddAssetsHtml = () => {

  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const [Isloading, setIsloading] = useState(false);
  let history = useHistory();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");


  useEffect(() => {}, []);


  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
      // else if (msg?.Name == message && type == 1) {
      // 	setErrorMessage(msg?.Desc);
      // }
      // else if (msg?.Name == message && type == 2) {
      // 	setMasterSystemAlertData(msg?.Desc);
      // }
    });
  }, []);

  const AssetsValidation = useMemo(
    () =>
      Yup.object().shape({
        type: Yup.string().required("Type is required."),
        serial_Number: Yup.string().required("Serial Number is required."),
        tally_Name: Yup.string().required("Tally Name is required."),
        address: Yup.string().required("Address is required."),
        description: Yup.string().required("Description is required."),
        warranty_Contact: Yup.string().required(
          "Warranty Contact is required."
        ),
        vendor: Yup.string().required("Vendor is required."),
        purchase_Date: Yup.string().required("Purchase Date is required."),
        warranty_Last_date: Yup.string().required(
          "Warranty Last Date is required."
        ),
        warranty_Number: Yup.string().required("Warranty Number is required."),
        units: Yup.string().required("Units is required."),
        discard_Date: Yup.string().required("Discard Date is required."),
        brand: Yup.string().required("Brand is required."),
        processor: Yup.string().required("Processor is required."),
        gen: Yup.string().required("Gen is required."),
        ram: Yup.string().required("Ram is required."),
        storage: Yup.string().required("Storage is required."),
        operating_System: Yup.string().required(
          "Operating System is required."
        ),
        current_Owner: Yup.string().required("Current Owner is required."),
        current_IP: Yup.string().required("Current IP is required."),
        last_Issued_Date: Yup.string().required(
          "Last Issued Date is required."
        ),
        issue_Letter_No: Yup.string().required("Issue Letter No is required."),
      }),
    []
  );

  const AssetsForm = useFormik({
    initialValues: {
      type: "",
      serial_Number: "",
      tally_Name: "",
      address: "",
      description: "",
      warranty_Contact: "",
      vendor: "",
      purchase_Date: "",
      warranty_Last_date: "",
      discard_Date: "",
      brand: "",
      processor: "",
      gen: "",
      ram: "",
      storage: "",
      operating_System: "",
      current_Owner: "",
      current_IP: "",
      last_Issued_Date: "",
      issue_Letter_No: "",
      assets_Image: "",
    },
    validationSchema: AssetsValidation,
    onSubmit: async (data) => {
      const body = {
        Id: data?.Id ?? 0,
        Type: data.type,
        Serial_Number: data.serial_Number,
        Tally_Name: data.tally_Name,
        Address: data.address,
        Description: data.description,
        Warranty_Contact: data.warranty_Contact,
        Vendor: data.vendor,
        Purchase_Date: data.purchase_Date,
        Warranty_Last_date: data.warranty_Last_date,
        Discard_Date: data.discard_Date,
        Brand: data.brand,
        Processor: data.processor,
        Gen: data.gen,
        Ram: data.ram,
        Storage: data.storage,
        Operating_System: data.operating_System,
        Current_Owner: data.current_Owner,
        Current_IP: data.current_IP,
        Last_Issued_Date: data.last_Issued_Date,
        Issue_Letter_No: data.issue_Letter_No,
        // Assets_Image: data.assets_Image,
      };
      try {
        // await AddAnnouncement(body);
        // if (data?.Id) {
        //   GetMasterSystemAlertList("Announcement_update", 0);
        //   setIsloading(false);
        // } else {
        //   GetMasterSystemAlertList("Announcement_added", 0);
        //   setIsloading(false);
        // }
        setIsloading(false);
        // $("#award-popup")?.click();
        // history.push(`/Announcement`);
      } catch (err) {
        // setIsloading(false);
        // toster.current.error(ERROR_LIST.DefaultError);
      }
    },
  });

  return (
    <div>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Add Asset</h2>
            </div>
            <div className="rightside-tabs">
              <Link to="/Assets/ListHtml">
                <button className="back-newticket w-auto float-right">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-left-short"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                    />
                  </svg>{" "}
                  Back
                </button>
              </Link>
            </div>
          </div>
          <div className="edit-ticket mt-4 mb-4">
            <div className="w-100">
              <form onSubmit={AssetsForm.handleSubmit}>
                <div className="row">
                  <div className="col-md-8">
                    <div className="employee-card tile-grid tile-grid-v1">
                      <div id="feed-post-1" className="addticketform">
                        <div className="third-section">
                          <div className="row gx-3 gy-1">
                            <div className="mb-3 col-lg-6">
                              <div className="cover-form">
                                <label className="form-label">
                                  {" "}
                                  Type<i className="inValidError">*</i>
                                </label>
                                <input
                                  type="text"
                                  cols="1"
                                  rows="4"
                                  name="type"
                                  placeholder="type of assets"
                                  className={
                                    "form-control bg-chng" +
                                    (AssetsForm.errors.type &&
                                    AssetsForm.touched.type
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.type}
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.type &&
                                AssetsForm.touched.type
                                  ? AssetsForm.errors.type
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-lg-6">
                              <div className="cover-form">
                                <label className="form-label">
                                  {" "}
                                  Serial Number
                                </label>
                                <input
                                  type="text"
                                  cols="1"
                                  rows="4"
                                  name="serial_Number"
                                  className={
                                    "form-control bg-chng" +
                                    (AssetsForm.errors.serial_Number &&
                                    AssetsForm.touched.serial_Number
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.serial_Number}
                                  placeholder="Serial Number"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.serial_Number &&
                                AssetsForm.touched.serial_Number
                                  ? AssetsForm.errors.serial_Number
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-lg-6">
                              <div className="cover-form">
                                <label className="form-label">
                                  Asset Tally Name
                                </label>
                                <input
                                  type="text"
                                  cols="1"
                                  rows="4"
                                  name="Asset_Tally_Name"
                                  className={
                                    "form-control bg-chng" +
                                    (AssetsForm.errors.Asset_Tally_Name &&
                                    AssetsForm.touched.Asset_Tally_Name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.Asset_Tally_Name}
                                  placeholder="Asset tally name"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.Asset_Tally_Name &&
                                AssetsForm.touched.Asset_Tally_Name
                                  ? AssetsForm.errors.Asset_Tally_Name
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-lg-6">
                              <div className="cover-form">
                                <label className="form-label">
                                  Mac Address
                                </label>
                                <input
                                  type="text"
                                  cols="1"
                                  rows="4"
                                  name="address"
                                  className={
                                    "form-control bg-chng" +
                                    (AssetsForm.errors.address &&
                                    AssetsForm.touched.address
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.address}
                                  placeholder="Mac Address"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.address &&
                                AssetsForm.touched.address
                                  ? AssetsForm.errors.address
                                  : null}
                              </div>
                            </div>

                            <div className="mb-3 col-md-12">
                              <div className="cover-form">
                                <label className="form-label">
                                  Description
                                </label>
                                <textarea
                                  rows="6"
                                  cols="1"
                                  name="description"
                                  className="form-control"
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.description}
                                  placeholder="Description of asset"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                          <div className="row gx-3 gy-1 mt-3">
                            <h4 className="">System Information</h4>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">
                                  Warranty Contact person
                                </label>
                                <input
                                  type="text"
                                  name="contact"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.contact &&
                                    AssetsForm.touched.contact
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.contact}
                                  placeholder="Warranty Contact person"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.contact &&
                                AssetsForm.touched.contact
                                  ? AssetsForm.errors.contact
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">
                                  Warranty Last date
                                </label>
                                <input
                                  type="date"
                                  name="date"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.warranty_Last_date &&
                                    AssetsForm.touched.warranty_Last_date
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.warranty_Last_date}
                                  placeholder="Warranty Last date"
                                />
                              </div>
                            </div>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">
                                  Warranty Number
                                </label>
                                <input
                                  type="number"
                                  name="warranty_Number"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.warranty_Number &&
                                    AssetsForm.touched.warranty_Number
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.warranty_Number}
                                  placeholder="Warranty number"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.warranty_Number &&
                                AssetsForm.touched.warranty_Number
                                  ? AssetsForm.errors.warranty_Number
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">Units</label>
                                <input
                                  type="number"
                                  name="units"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.units &&
                                    AssetsForm.touched.units
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.units}
                                  placeholder="Units"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.units &&
                                AssetsForm.touched.units
                                  ? AssetsForm.errors.units
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">
                                  Discard Date
                                </label>
                                <input
                                  type="date"
                                  onClick={(e) =>
                                    e.target.showPicker && e.target.showPicker()
                                  }
                                  name="discard_Date"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.discard_Date &&
                                    AssetsForm.touched.discard_Date
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.discard_Date}
                                  placeholder="Discard Date"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.discard_Date &&
                                AssetsForm.touched.discard_Date
                                  ? AssetsForm.errors.discard_Date
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-md-4">
                              <div className="cover-form">
                                <label className="form-label">
                                  Date of Purchase
                                </label>
                                <input
                                  type="date"
                                  name="purchase_Date"
                                  onClick={(e) =>
                                    e.target.showPicker && e.target.showPicker()
                                  }
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.purchase_Date &&
                                    AssetsForm.touched.purchase_Date
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.purchase_Date}
                                  placeholder="Date of Purchase"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.purchase_Date &&
                                AssetsForm.touched.purchase_Date
                                  ? AssetsForm.errors.purchase_Date
                                  : null}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-12 mt-3">
                            <div className="row gx-3 gy-1 mb-3">
                              <h4 className="">Laptop/Desktop Information</h4>
                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Modal(Brand)
                                  </label>
                                  <input
                                    type="text"
                                    name="storage"
                                    className={
                                      "form-control" +
                                      (AssetsForm.errors.storage &&
                                      AssetsForm.touched.storage
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={AssetsForm.handleChange}
                                    value={AssetsForm.values.storage}
                                    placeholder="Brand"
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {AssetsForm.errors.storage &&
                                  AssetsForm.touched.storage
                                    ? AssetsForm.errors.storage
                                    : null}
                                </div>
                              </div>
                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Make(Gen)
                                  </label>
                                  <input
                                    type="text"
                                    name=""
                                    className="form-control "
                                    placeholder="Brand"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Size (Storage)
                                  </label>
                                  <input
                                    type="text"
                                    name=""
                                    className="form-control "
                                    placeholder="Brand"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row gx-3 gy-1">
                              <h4 className="">Make Modal</h4>
                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Other 1 (Ram)
                                  </label>
                                  <input
                                    type="text"
                                    name=""
                                    className="form-control "
                                    placeholder="Ram"
                                  />
                                </div>
                              </div>

                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Other 2 (Processor)
                                  </label>
                                  <input
                                    type="text"
                                    name=""
                                    className="form-control "
                                    placeholder="Processor"
                                  />
                                </div>
                              </div>

                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Other 3 (Operating System)
                                  </label>
                                  <input
                                    type="text"
                                    name="operating_System"
                                    className={
                                      "form-control" +
                                      (AssetsForm.errors.operating_System &&
                                      AssetsForm.touched.operating_System
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={AssetsForm.handleChange}
                                    value={AssetsForm.values.operating_System}
                                    placeholder="Operating System"
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {AssetsForm.errors.operating_System &&
                                  AssetsForm.touched.operating_System
                                    ? AssetsForm.errors.operating_System
                                    : null}
                                </div>
                              </div>

                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">Other 4</label>
                                  <input
                                    type="text"
                                    name=""
                                    className="form-control "
                                    placeholder="Ram"
                                  />
                                </div>
                              </div>

                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">Other 5 </label>
                                  <input
                                    type="text"
                                    name=""
                                    className="form-control "
                                    placeholder="Processor"
                                  />
                                </div>
                              </div>

                              <div className="mb-3 col-md-4">
                                <div className="cover-form">
                                  <label className="form-label">Other 6 </label>
                                  <input
                                    type="text"
                                    name=""
                                    className="form-control "
                                    placeholder="Operating System"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* <div className="mb-3 col-md-12 mt-3">
                              <h4 className="">Owner </h4>
                                <div className="cover-form">
                                  <label className="form-label">Current Owner</label>
                                  <input
                                    type="text"
                                    
                                    name=""
                                    className=
                                      "form-control "
                                    placeholder="Operating System"
                                  />
                              </div>
                            </div> */}
                          {/* <div className="row gx-3 gy-1 mt-3">
                             
                            
                            <div className="mb-3 col-md-6">
                              <div className="cover-form">
                                <label className="form-label">Current IP</label>
                                <input
                                  type="text"
                                  name="current_IP"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.current_IP &&
                                    AssetsForm.touched.current_IP
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.current_IP}
                                  placeholder="Operating System"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.current_IP &&
                                AssetsForm.touched.current_IP
                                  ? AssetsForm.errors.current_IP
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-md-6">
                              <div className="cover-form">
                                <label className="form-label">
                                  {" "}
                                  Last Issued Date
                                </label>
                                <input
                                  type="text"
                                  name="last_Issued_Date"
                                   onClick={(e) =>
                                        e.target.showPicker &&
                                        e.target.showPicker()
                                      }
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.last_Issued_Date &&
                                    AssetsForm.touched.last_Issued_Date
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.last_Issued_Date}
                                  placeholder="Operating System"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.last_Issued_Date &&
                                AssetsForm.touched.last_Issued_Date
                                  ? AssetsForm.errors.last_Issued_Date
                                  : null}
                              </div>
                            </div>
                            <div className="mb-3 col-md-6">
                              <div className="cover-form">
                                <label className="form-label">
                                  Issue Letter No
                                </label>
                                <input
                                  type="text"
                                  name="Issue_Letter_No"
                                  className={
                                    "form-control" +
                                    (AssetsForm.errors.issue_Letter_No &&
                                    AssetsForm.touched.issue_Letter_No
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={AssetsForm.handleChange}
                                  value={AssetsForm.values.issue_Letter_No}
                                  placeholder="Operating System"
                                />
                              </div>
                              <div className="invalid-feedback">
                                {AssetsForm.errors.issue_Letter_No &&
                                AssetsForm.touched.issue_Letter_No
                                  ? AssetsForm.errors.issue_Letter_No
                                  : null}
                              </div>
                            </div>
                           
                            </div> */}
                          <div className="row justify-content-end">
                            <div className="col-md-3">
                              <Link to="/Assets/DetailHtml">
                                <button
                                  className="btn btn-purple btn-block"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              </Link>
                            </div>
                          </div>
                          {/* </form> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-header bg-transparent border-bottom-0">
                        <h4 className="">Status</h4>
                      </div>
                      <div className="card-body">
                        <div>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option selected>New</option>
                            <option value="1">In progress</option>
                            <option value="2">Resolved</option>
                            <option value="3">On hold</option>
                            <option value="3">Approval Awaited</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-body">
                        <h5 className="">Owner Detail</h5>
                        <div className="assets-attach__wrapper">
                          <div className="option-g">
                            <div className="info mb-0">
                              <div className="info__items_detail">
                                <div className="image">
                                  <img
                                    src="http://devbox.bizbrolly.com:4006/Uploads/c737/PI/101\cropped_c9df_202508202430.jpg"
                                    alt="zip.png"
                                  />
                                </div>
                                <div className="div">
                                  <h6>Liam Shep Thompson</h6>
                                  <span>On&nbsp;Oct 31 2025</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header bg-transparent border-bottom-0">
                        <h4 className="">Assets image and files</h4>
                      </div>
                      <div className="card-body">
                        <div className="loadresumes">
                          <div className="inner">
                            <img src="" className="editaddimg" />
                          </div>
                          <label
                            htmlFor="file-upload"
                            className="custom-file-upload"
                          >
                            <i
                              className="fa fa-upload me-2"
                              aria-hidden="true"
                            ></i>
                            Upload multiple Image and files
                          </label>

                          <input
                            type="file"
                            multiple=""
                            id="file-upload"
                            className="form-control"
                            name="BannerImage"
                            accept="image/png, image/gif, image/jpeg"
                            style={{ display: "none" }}
                          />
                        </div>

                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAssetsHtml;
